<template>
  <div>

    <div class='sc-list' >

      <div  class="sc-item" v-for="(item,index) in movieList" :key="index">

        <MovieItem :data="item"></MovieItem>
      </div>

    </div>

  </div>
</template>

<script>
import MovieItem from './MovieItem'
import {getMovieList} from '../../../../request/api'
export default {
  name: 'Movie',
  components: {MovieItem},
  data () {
    return {
      movieList: [

      ]
    }
  },
  methods: {
    init () {
      getMovieList().then(res => {
        console.log(res)

        if (res.code === '90') {
          this.movieList = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        // error

        console.log(error)
      })
    }
  },
  created () {
    this.init()
  }
}
</script>

<style scoped>
.sc-item{
  text-align: center;
  /*float: left;*/

  margin-top:20px;
  margin-bottom:20px;
  /*margin: 20px auto;*/

}
.sc-list{
  flex-wrap: wrap;
  /*margin-left:@lrwith;*/
  /*margin-right:@lrwith;*/
  display: flex;
  justify-content: space-around;
  /* !主轴水平时!决定了item在交叉轴上的对齐方式，可能的值有flex-start|flex-end|center|baseline|stretch */
  /*align-items: center;*/
}
</style>



// WEBPACK FOOTER //
// src/components/pc/pages/movie/Movie.vue